import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { Collapsible, CollapsibleContent, CollapsibleHeader } from '../../../components/Collapsible';
import Loading from '../../../components/LoadingPlaceholder';
import messages from '../../../utils/translationMessages';
import { addEvent } from '../../../store/actions/dataLayer';
import { TRACKING_EVENTS } from '../../../constants/dataLayer';
import {
  TRIDENT_APP_URL,
  GREEN_STAR,
  ORANGE_STAR,
  GOOGLE_ICON,
  EXTERNAL_LINK,
  BOAT_SMALL,
  BT_FINANCING_LOGO,
  TRIDENT_FAQ_LOGO
} from '../../../constants/BoatLoans';
import './styles.css';

class BoatLoans extends PureComponent {

  state = {
    hidden: false,
    showPhoneNumber: false,
  }

  componentDidUpdate = () => {
    if (this.props.open !== this.state.openComponent){
      this.setState({
        openComponent: this.props.open
      });
    }
  }

  removeEncoding = (text) => text.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

  showPhoneNumber = () => {
    this.props.addEvent(TRACKING_EVENTS.REVEAL_PHONE_NUMBER);

    this.setState(prevState => {
      return { showPhoneNumber: !prevState.showPhoneNumber };
    });
  };

  callPhoneNumber = () => {
    this.props.addEvent(TRACKING_EVENTS.DIAL_PHONE_NUMBER);
  }

  hideStar = (pos, score) => {
    let hide = false;

    if ((score < 2.1) || // no stars
    (score >= 2.1 && score < 3.1 && pos >= 4) || // 3 stars
    (score >= 3.1 && score < 4.1 && pos === 5)) { // 4 stars
      hide = true;
    }

    return hide;
  };

  renderOverallStars = (score) => {
    return Array.from(Array(5).keys())
      .map((index) => {
        if (!this.hideStar(index + 1, score)) {
          return <img alt="green review star" key={index} src={GREEN_STAR} />;
        }
        return null;
      });
  };

  renderReviewStars = (review) => {
    return Array.from(Array(review.stars).keys())
      .map((index) => <img alt="orange review star" key={index} src={ORANGE_STAR} />);
  };

  renderTestimonials = (reviews) => {
    return reviews.map((review, i) =>
      <div className="review" key={i}>
        <div className="top-row">
          <div className="review-author">{review.author}</div>
          <div className="review-google-icon"><img alt="google icon" src={GOOGLE_ICON} /></div>
        </div>
        <div className="review-stars">
          {this.renderReviewStars(review)}
        </div>
        <div className="review-text"><div dangerouslySetInnerHTML={{ __html: this.removeEncoding(review.review) }} /></div>
      </div>
    );
  }

  renderLoans(editorialContent) {
    const {
      description: mainDescription,
      reviewsSection: { score, totalReviews, reviews },
      ratesSection: { description: ratesDescription },
      learnMoreSection: { description: learnMoreDescription }
    } = editorialContent;

    const {
      breakpoint,
      counter,
      intl: { formatMessage: t }
    } = this.props;

    const showPhoneNumber = this.state.showPhoneNumber;

    return (
      <CollapsibleContent open={this.state.openComponent} openCounter={counter} initialState="open" classOverride="details">
        <CollapsibleHeader>
          {t(messages.boatLoansContent.bdpBoatLoansSection.title)}
        </CollapsibleHeader>
        <Collapsible type="no-pad">
          <div className="content-wrapper">
            <div className="loans-container">
              <div className="boat-loans-description section-bottom-border">
                <div dangerouslySetInnerHTML={{ __html: this.removeEncoding(mainDescription) }} />
                <div className="bl-desc-cta-buttons-row">
                  { breakpoint === 'desktop' && <div className="bl-desc-cta-button callus desktop" onClick={this.showPhoneNumber}>{showPhoneNumber ? '888-356-6005' : t(messages.boatLoansContent.bdpBoatLoansSection.callUs)}</div> }
                  { breakpoint !== 'desktop' &&
                    <div className="bl-desc-cta-button callus mobile" onClick={this.callPhoneNumber}>
                      <a
                        href="tel:888-356-6005"
                        data-reporting-click-internal-link-type="click"
                        data-reporting-click-internal-link-id="yacht loans - call us"
                      >
                        {t(messages.boatLoansContent.bdpBoatLoansSection.callUs)}
                      </a>
                    </div>
                  }
                  <div className="bl-desc-cta-button applynow">
                    <a
                      href={`${TRIDENT_APP_URL}&utm_campaign=BDPyachtloansection`}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-reporting-click-internal-link-type="click"
                      data-reporting-click-internal-link-id="yacht loans - apply now"
                    >
                      <span className="bl-desc-cta-icon"><img alt="link arrow" src={EXTERNAL_LINK} /></span>
                      <span className="bl-desc-cta">
                        {t(messages.boatLoansContent.bdpBoatLoansSection.applyNow)}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="boat-loans-reviews section-bottom-border">
                <div className="section-title">
                  {t(messages.boatLoansContent.bdpBoatLoansSection.reviews)}
                </div>
                <div className="section-body">
                  <div className="reviews-summary">
                    <div className="logos">
                      <div className="review-logo-boat"><img alt="boat logo" src={BOAT_SMALL} /></div>
                      <div className="review-logo-bt-financing"><img alt="boat trader financing logo" src={BT_FINANCING_LOGO} /></div>
                    </div>
                    <div className="review-rating">
                      <div className="review-overall-score">{score}</div>
                      <div className="review-overall-stars">{this.renderOverallStars(score)}</div>
                    </div>
                    <div className="review-total-count">{`Based on ${totalReviews} reviews`}</div>
                  </div>
                  <div className="testimonials">{this.renderTestimonials(reviews)}</div>
                </div>
              </div>
              <div className="boat-loans-rates section-bottom-border">
                <div className="section-title">
                  {t(messages.boatLoansContent.bdpBoatLoansSection.rates)}
                </div>
                <div dangerouslySetInnerHTML={{ __html: this.removeEncoding(ratesDescription) }} />
              </div>
              <div className="boat-loans-faqs custom">
                <div className="section-title">
                  {t(messages.boatLoansContent.bdpBoatLoansSection.faqs)}
                </div>
                <div dangerouslySetInnerHTML={{ __html: this.removeEncoding(learnMoreDescription) }} />
                <div className="powered-by">
                  <div className="text">
                    {t(messages.boatLoansContent.bdpBoatLoansSection.poweredBy)}
                  </div>
                  <div className="trident-logo"><img alt="trident logo" src={TRIDENT_FAQ_LOGO} /></div>
                </div>
              </div>
            </div>
          </div>
        </Collapsible>
      </CollapsibleContent>
    );
  }

  renderLoading() {
    return (
      <>
        <Loading type="text" />
        <Loading type="text" />
        <Loading type="text" />
      </>
    );
  }

  render() {
    const {
      isLoading,
      listing,
      editorialContent
    } = this.props;

    return (
      <div className="boat-loans-wrapper">
        <div id="boat-loans-anchor"></div>
        <div id="boat-loans" className={classnames('boat-loans', { 'hidden-boat-loans': this.state.hidden })}>
          {isLoading || !listing.id ?
            this.renderLoading()
            :
            editorialContent?.isValid ? this.renderLoans(editorialContent) : <div className="editorial-errors">{ editorialContent?.errors }</div>
          }
        </div>
      </div>
    );
  }
}

BoatLoans.propTypes = {
  isLoading: PropTypes.bool,
  listing: PropTypes.object.isRequired,
  editorialContent: PropTypes.object.isRequired,
  breakpoint: PropTypes.string.isRequired,
  counter: PropTypes.number.isRequired,
  open: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  addEvent: PropTypes.func.isRequired,
};

export default connect(null, (dispatch) =>
  bindActionCreators({addEvent}, dispatch)
)(injectIntl(BoatLoans));
